/* src/app/shared/components/image-with-camera/image-with-camera.component.scss */
.image-container {
  height: 32px;
  width: 32px;
  background-color: #f8f8f8;
  border: solid 1.3px #c8c7cc;
  border-radius: 50%;
  display: inline-block;
  align-items: center;
  text-align: center;
  line-height: 32px;
  margin-right: 8px;
  color: white;
}
.image-container img {
  vertical-align: initial;
}
@media (max-width: 599px) {
  .image-container {
    margin-right: 0;
  }
}
/*# sourceMappingURL=image-with-camera.component.css.map */
